// Shared "bento" card design tokens — mirrors the visual language used on
// the admin dashboard (src/pages/admin/Dashboard.js's local `C`/`cardSx`)
// so the patient/therapist portal cards read as one system with the rest
// of the app, without importing from that page-local file directly.
export const C = {
  bg: "#F1F1F1",
  surface: "#FFFFFF",
  ink: "#282828",
  primary: "#16498A",
  tint2: "#8FB2DA",
  tintBg: "#EAF1FA",
  gray2: "#B9BDC2",
  gray7: "#EDEDED",
  textSecondary: "#8a8a8a",
  textFaint: "#a4a4a4",
  border: "rgba(40,40,40,0.06)",
};

export const cardSx = { borderRadius: "24px", background: C.surface, border: `1px solid ${C.border}` };

// Less-rounded variant for list/table surfaces (Orders, Reports, Patients)
// — the 24px radius reads right for the dashboard's bento stat cards, but
// is too rounded for tables/accordions on the other portal pages.
export const compactCardSx = { borderRadius: "12px", background: C.surface, border: `1px solid ${C.border}` };
